class BestsellersSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.js-bestsellers-slider');
    if (!this.slider || this.slider.swiper) return;

    const gap = parseInt(this.dataset.swiperGap, 10);
    const gapMobile = parseInt(this.dataset.swiperGapMobile, 10);

    new Swiper(this.slider, {
      slidesPerView: 'auto',
      spaceBetween: Number.isNaN(gapMobile) ? 12 : gapMobile,
      watchOverflow: true,
      navigation: {
        prevEl: Array.from(this.querySelectorAll('.js-bestsellers-prev')),
        nextEl: Array.from(this.querySelectorAll('.js-bestsellers-next, .js-bestsellers-overlay-next'))
      },
      breakpoints: {
        750: {
          spaceBetween: Number.isNaN(gap) ? 22 : gap
        }
      },
      on: {
        afterInit: (swiper) => this.syncEndOffset(swiper),
        resize: (swiper) => this.syncEndOffset(swiper)
      }
    });
  }

  disconnectedCallback() {
    if (this.slider && this.slider.swiper) this.slider.swiper.destroy(true, true);
  }

  syncEndOffset(swiper) {
    const slidesWidth =
      swiper.slides.reduce((width, slide) => width + slide.offsetWidth, 0) +
      Math.max(0, swiper.slides.length - 1) * (swiper.params.spaceBetween || 0);
    const endOffset = window.matchMedia('(min-width: 1200px)').matches ? 60 : 18;
    const target = slidesWidth > swiper.width ? endOffset : 0;
    if (swiper.params.slidesOffsetAfter !== target) {
      swiper.params.slidesOffsetAfter = target;
      swiper.update();
    }
  }
}

if (!customElements.get('bestsellers-slider')) {
  customElements.define('bestsellers-slider', BestsellersSlider);
}
